export class GRAPHRSLTVIEW_GROUP {

  ID_Abs: number;
  CriteriaName_Abs: string;
  LineGraphName_Abs: string;
  ResultType_Abs: string;
  ParamsSet_Abs: string;
  OrderID_Abs: number;
  GraphDisplayOrNot_Abs: number;
  GroupByColName_Abs: string;
  DefaultOrNot_Abs: number;
  Title: string;
  selectedGraphButton: boolean;
  GraphDeleted_Abs: boolean;

  constructor() {
    this.ParamsSet_Abs = "";
    this.ID_Abs = 0;
    let title = "Select from  below Result Type";
    this.Title = "";
    this.selectedGraphButton = false;
    this.GraphDeleted_Abs = false;
    this.GraphDisplayOrNot_Abs = 1;
  }

}
